import {Modal} from "antd";
import {useEffect, useState} from "react";
import {chatService} from "../../../../services/chatService";
import {Spinner} from "../../../../components/DesignSystem/Spinner/Spinner";
import ReactMarkdown from 'react-markdown';

export const SqlImproveFixModal = ({chatId, onClose, sql}) => {

    const [fix, setFix] = useState("");
    const [loading, setLoading] = useState(false);

    useEffect(() => {

        setLoading(true);

        chatService.ask(chatId, `I have the following SQL query: ${sql}. Could you please fix it or improve it? I am using DuckDB`).then(response => {
            setFix(response.data);
        }).catch(error => {
            console.error("Error explaining SQL query:", error);
        }).finally(() => {
            setLoading(false);
        });

    }, []);

    return <Modal title={"Improve & Fix query"} open={true} width={1200} onCancel={onClose} footer={null} centered>
        <Spinner spinning={loading} tip={"Suggestion will be shown here..."}>
            <div style={{fontSize: 14, color: '#333', padding: 10, background: '#f9f9f9', overflowY: 'auto', height: '600px'}}>
                <ReactMarkdown>{fix}</ReactMarkdown>
            </div>
        </Spinner>
    </Modal>

}